import { useState } from 'react';

interface HeaderProps {
  isFixed: boolean;
}

export default function Header({ isFixed }: HeaderProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      setIsMobileMenuOpen(false);
    }
  };

  const menuItems = [
    { label: 'Inicio', id: 'hero' },
    { label: 'Sobre Nosotros', id: 'about' },
    { label: 'Metodología', id: 'methodology' },
    { label: 'Qué Ofrecemos', id: 'offer' },
    { label: 'Horarios', id: 'schedule' },
    { label: 'Por Qué Elegirnos', id: 'why' },
    { label: 'Contacto', id: 'contact' }
  ];

  return (
    <header
      className={`w-full z-50 transition-all duration-300 bg-white ${
        isFixed ? 'fixed top-0 shadow-md' : 'absolute top-0'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex-shrink-0">
            <img
              src="https://static.readdy.ai/image/dd95bba129a4e648d9c1ab0ceae0e9b1/8b930cfb7da67169cd8afa37527c0dcf.jpeg"
              alt="Duendecillos Let's Play"
              className="h-14 w-auto object-contain cursor-pointer"
              onClick={() => scrollToSection('hero')}
            />
          </div>

          {/* Desktop Menu */}
          <nav className="hidden lg:flex items-center space-x-8">
            {menuItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="text-sm font-medium transition-colors whitespace-nowrap text-gray-700 hover:text-[#FF7F6E]"
              >
                {item.label}
              </button>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:block">
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-[#FF7F6E] text-white px-6 py-3 rounded-full font-medium hover:bg-[#ff6b58] transition-all shadow-md hover:shadow-lg whitespace-nowrap"
            >
              Solicitar visita
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-gray-800`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200 shadow-lg">
          <div className="px-4 py-4 space-y-3">
            {menuItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 rounded-lg transition-colors whitespace-nowrap"
              >
                {item.label}
              </button>
            ))}
            <button
              onClick={() => scrollToSection('contact')}
              className="w-full bg-[#FF7F6E] text-white px-6 py-3 rounded-full font-medium hover:bg-[#ff6b58] transition-all shadow-md whitespace-nowrap"
            >
              Solicitar visita
            </button>
          </div>
        </div>
      )}
    </header>
  );
}